import React, { forwardRef, useEffect, useState }       from 'react';
import { createStyles, Group, Select, Text, TextInput } from '@mantine/core';
import { FormFieldType }                                from '@core/components/form/skin-active/form-field-type';
import { IconPhoneCall }                                from '@tabler/icons';


const useStyles = createStyles((
    theme: {
        colors: { [x: string]: any[] };
        colorScheme: string;
        fn: any;
        fontSizes: any;
        spacing: any;
        white: any;
    }) => ({

    mainPhone: {
        width: '100%',
        [theme.fn.smallerThan('sm')]: {
            flexDirection: 'column',
        },
    },

    selectPhone: {
        position: 'relative',
        width: 'calc(100%/3)',

        [theme.fn.smallerThan('sm')]: {
            width: '100%',
        },

        'input': {
            height: 'auto',
            paddingTop: 40,
            paddingBottom: 4,
            fontSize: 14,

            [theme.fn.largerThan('sm')]: {
                borderRight: 0,
                borderBottomRightRadius: 0,
                borderTopRightRadius: 0,
            },

            [theme.fn.smallerThan('sm')]: {
                borderBottom: 0,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            },

        },

        '& .mantine-Input-icon': {
            top: 38,
            fontSize: 20,
        },

        'label': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 20 / 2,
            zIndex: 1,
        },

        '& .mantine-Select-description': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            zIndex: 1,
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[7],
        },

        '& .mantine-Select-input::placeholder': {
            color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[7],
        },

        '& .mantine-InputWrapper-error': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.xs,
            left: theme.spacing.sm,
            top: 28,
            zIndex: 1,
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
        },

    },

    textInputPhone: {
        position: 'relative',
        width: 'calc(70%)',

        [theme.fn.smallerThan('sm')]: {
            width: '100%',
        },

        'input': {
            height: 'auto',
            paddingTop: 40,
            paddingBottom: 4,
            fontSize: 14,

            [theme.fn.largerThan('sm')]: {
                borderBottomLeftRadius: 0,
                borderTopLeftRadius: 0,
            },

            [theme.fn.smallerThan('sm')]: {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                marginTop: -2,
            },

        },

        '& .mantine-Input-icon': {
            top: 38,
            fontSize: 20,
        },

        'label': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.sm,
            paddingLeft: theme.spacing.sm,
            paddingTop: 20 / 2,
            zIndex: 1,
        },

        '& .mantine-TextInput-description': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.xs,
            paddingLeft: theme.spacing.sm,
            paddingTop: 28,
            zIndex: 1,
        },

        '& .mantine-InputWrapper-error': {
            position: 'absolute',
            pointerEvents: 'none',
            fontSize: theme.fontSizes.xs,
            left: theme.spacing.sm,
            top: 28,
            zIndex: 1,
            backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.white,
        },

    },

}));

interface ItemProps extends React.ComponentPropsWithoutRef<'div'> {
    label: string;
}

export const PhoneNumberField: React.FC<FormFieldType<any>> = ({
                                                                   subCompData,
                                                                   variable,
                                                                   subCompVariable,
                                                                   form,
                                                                   errorMsg,
                                                                   fieldLabel,
                                                                   placeholder,
                                                                   description,
                                                                   inputVariant,
                                                                   required,
                                                                   disabled,
                                                                   searchable,
                                                                   clearable,
                                                                   onChange
                                                               }) => {
    const { classes } = useStyles();

    const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
        ({ label, ...others }: ItemProps, ref) => (
            <div ref={ref} {...others}>
                <Group noWrap={true}>
                    <div>
                        <Text size="sm">{label}</Text>
                    </div>
                </Group>
            </div>
        )
    );

    const [codes, setCodes] = useState([]);

    useEffect(() => {

        if (subCompData !== null) {

            const data = subCompData?.map((val) => {
                return {
                    label: `+ ${val}`,
                    value: val
                };
            });

            setCodes(data);
        }

    }, [subCompData]);

    return (
        <Group className={classes.mainPhone} noWrap={true} spacing={0} position="left" mt="sm">

            {
                subCompVariable &&
                <Select
                    className={classes.selectPhone}
                    radius="xs"
                    error={errorMsg}
                    required={required}
                    itemComponent={SelectItem}
                    label="Country Code"
                    description="Please select a code"
                    disabled={disabled}
                    variant={inputVariant}
                    searchable={searchable}
                    clearable={clearable}
                    nothingFound="No options"
                    maxDropdownHeight={400}
                    transition="pop-top-left"
                    transitionDuration={80}
                    transitionTimingFunction="ease"
                    // data={data}
                    data={codes}
                    {...form.getInputProps(subCompVariable)}
                />
            }

            <TextInput
                className={classes.textInputPhone}
                radius="xs"
                type="number"
                label={fieldLabel}
                placeholder={placeholder}
                description={description}
                disabled={disabled}
                variant={inputVariant}
                icon={<IconPhoneCall size={16} stroke={1}/>}
                {...form.getInputProps(variable)}
            />

        </Group>
    );
};
